import React from 'react';

import { Box, Heading, Text } from '@primer/components'
import LazyLoad from 'react-lazyload';
import { Link } from "react-router-dom";


export default function (props) {
  return (
      <Box alignItems="center" className="container-lg clearfix mt-8 mb-4 pl-4 pr-4 pl-md-0 pr-md-0">
        <Box className="col-md-12">
          <Heading>Improve your productivity</Heading>    
          <Text className="f3">Simplify upgrading Django with our <Link to="/features/django/compare-django-release-notes/3.0.0/3.2.7">changelog comparison tool</Link>. View all changes between two releases: bug fixes, features, and deprecations all in one place rather than manually tabbing through multiple release notes and risking missing something important.</Text>
        </Box>
        <Box className="col-md-12 mt-8">
          <LazyLoad height="380px">
            <img src="/mockup-release-notes-laptop-isolated.png" width="100%" alt=""  />
          </LazyLoad>
        </Box>
      </Box>
    )
}